import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useNavigate } from "@tanstack/react-router";
import { RouterProvider } from "react-aria-components";
import {
  queryClient,
  createAuthService,
} from "@bfc-software/bfc-web-ui/lib/aaa-api-client";
import type * as React from "react";
import { AuthContextProvider, BugTracking } from "@bfc-software/app-toolbox";
import { PalletThemeProvider } from "@bfc-software/pallet";
import { ForcedExpiryProvider } from "@bfc-software/bfc-web-ui/lib/authenticated-api";
import { globalCommandPaletteComands } from "@bfc-software/bfc-web-ui/lib/global-command-palette-commands";

import { CommandPaletteProvider } from "./command-palette";

const authService = createAuthService();

export default function Providers({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const push = (to: string) => navigate({ to });

  return (
    <RouterProvider navigate={push}>
      <QueryClientProvider client={queryClient}>
        <AuthContextProvider authService={authService}>
          <ForcedExpiryProvider>
            <PalletThemeProvider>
              <CommandPaletteProvider
                initialCommands={globalCommandPaletteComands}
              >
                <BugTracking.ErrorBoundary>
                  {children}
                </BugTracking.ErrorBoundary>
              </CommandPaletteProvider>
            </PalletThemeProvider>
          </ForcedExpiryProvider>
        </AuthContextProvider>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </RouterProvider>
  );
}
